import {Container, media} from '@modifi/ui'
import styled from 'styled-components'

export const AlignedContainer = styled(Container)`
  margin-top: -40vh;
  padding-bottom: 32px;
  ${media.xs`
    margin-top: -32vh;
  `}
  @media (max-width: 350px) {
    margin-top: -16vh;
  }
`
